import { adminHttpClient } from '../commons/adminHttpClient'

export type EditAppConfigurationRequest = {
  key: string
  value: string
}

const editAppConfiguration = (request: EditAppConfigurationRequest): Promise<void> => {
  return adminHttpClient.put('/AppConfigurations', request)
}

export default editAppConfiguration
